import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';

import DeviceGroupsHeader from './DeviceGroupsHeader';
import DeviceGroupsTable from './DeviceGroupsTable';
import AddGroupDialogBox from './AddGroupDialogBox';
import NoDataAvailableMessage from '../../components/NoDataAvailable';
import { useGetGroupsQuery, useAddGroupMutation } from '../../services/api';

const DeviceGroups = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const { role, company } = useSelector((state) => state.global);

    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [selectedSites, setSelectedSites] = useState([]);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);

    // API
    const { data, isLoading, isError, refetch } = useGetGroupsQuery(company);
    const groups = data?.groups ?? [];
    const [addGroup, { isAddLoading }] = useAddGroupMutation();

    const handleOpenAddDialog = () => setOpenAddDialog(true);
    const handleCloseDialog = () => setOpenAddDialog(false);

    // Hnadle add group
    const handleAddGroup = async () => {
        try {
            await addGroup({
                name: groupName,
                sites: selectedSites,
                devices: selectedDevices,
                users: selectedUsers,
                company,
            }).unwrap();

            setGroupName('');
            setSelectedSites([]);
            setSelectedDevices([]);
            setSelectedUsers([]);

            handleCloseDialog();

            refetch();
        } catch (err) {
            console.error('Failed to add group:', err);
        }
    };

    return (
        <Box m={isSmallScreen ? '0.5rem' : '1rem 2.5rem'} pb="2rem" height="80%" borderRadius="15px">
            <DeviceGroupsHeader role={role} handleOpenAddDialog={handleOpenAddDialog} />

            {isLoading ? (
                <NoDataAvailableMessage />
            ) : isError ? (
                <NoDataAvailableMessage message="Failed to load device groups." />
            ) : groups.length === 0 ? (
                <NoDataAvailableMessage message="No device groups available." />
            ) : (
                <DeviceGroupsTable deviceGroups={groups} refetch={refetch} />
            )}

            <AddGroupDialogBox
                open={openAddDialog}
                handleCloseDialog={handleCloseDialog}
                theme={theme}
                handleAddGroup={handleAddGroup}
                isAddLoading={isAddLoading}
                selectedSites={selectedSites}
                setSelectedSites={setSelectedSites}
                selectedDevices={selectedDevices}
                setSelectedDevices={setSelectedDevices}
                selectedUsers={selectedUsers}
                setSelectedUsers={setSelectedUsers}
                groupName={groupName}
                setGroupName={setGroupName}
            />
        </Box>
    );
};

export default DeviceGroups;
